module.exports = __webpack_public_path__ + "img/shield-approved.402fde1a.svg";